import { MARQUEE } from "@/lib/content";

const Star = () => (
  <svg className="h-5 w-5 shrink-0 text-[#0D6EFD] md:h-7 md:w-7" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 0l2.6 9.4L24 12l-9.4 2.6L12 24l-2.6-9.4L0 12l9.4-2.6z" />
  </svg>
);

export const Marquee = () => {
  const items = [...MARQUEE, ...MARQUEE];
  return (
    <section data-testid="editorial-marquee" className="overflow-hidden border-y border-slate-200 bg-white py-6 md:py-8">
      <div className="marquee-track flex w-max items-center gap-10 md:gap-16">
        {[...items, ...items].map((t, i) => (
          <span key={i} className="flex items-center gap-10 md:gap-16">
            <span className={`font-display whitespace-nowrap text-3xl font-bold tracking-tight md:text-5xl ${i % 2 ? "text-transparent [-webkit-text-stroke:1.2px_#0B132B]" : "text-[#0B132B]"}`}>{t}</span>
            <Star />
          </span>
        ))}
      </div>
    </section>
  );
};
